import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/5 bg-ink-950 px-5 py-10 sm:px-8" data-id="element-129" data-mp="32wd0e9mw79qd">
      <div className="mx-auto flex w-full max-w-4xl flex-col gap-3 text-center" data-id="element-130" data-mp="3gg10u7y865zr">
        <p className="text-sm font-semibold text-white" data-id="element-131" data-mp="32onk11rpbm8f">iPhone Experto</p>
        <p className="text-xs leading-relaxed text-white/40" data-id="element-132" data-mp="36pfv80k4w17c">
          Este producto es una guía educativa independiente y no está afiliado,
          patrocinado ni respaldado por Apple Inc. iPhone, iOS, iCloud, AirDrop,
          Face ID y Siri son marcas registradas de Apple Inc.
        </p>
        <p className="text-xs text-white/30" data-id="element-133" data-mp="3lec9wggp4cgx">
          © {new Date().getFullYear()} iPhone Experto. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}